import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, Link2, MousePointerClick, LogOut } from "lucide-react";
import { Brand } from "@/components/Brand";
import { useAuth } from "@/context/AuthContext";
import { LOGOUT } from "@/constants/testIds";

const NAV = [
  { to: "/dashboard", label: "Overview", icon: LayoutDashboard, end: true, id: "overview" },
  { to: "/dashboard/links", label: "Links", icon: Link2, id: "links" },
  { to: "/dashboard/clicks", label: "Click logs", icon: MousePointerClick, id: "clicks" },
];

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="grain min-h-screen bg-ink flex flex-col md:flex-row">
      <aside className="md:w-64 md:min-h-screen border-b md:border-b-0 md:border-r border-slate-800 bg-slate-950/60 p-5 flex md:flex-col gap-6">
        <Brand to="/dashboard" />
        <nav className="flex md:flex-col gap-1 flex-1 overflow-x-auto md:mt-6">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`sidebar-nav-${n.id}`}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive ? "bg-emerald-500/10 text-emerald-400" : "text-slate-400 hover:text-white hover:bg-slate-800/60"}`}>
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:block text-xs text-slate-500 truncate" data-testid="sidebar-user-email">{user?.email}</div>
        <button data-testid={LOGOUT.button} onClick={logout}
          className="flex items-center gap-2 text-sm text-slate-400 hover:text-red-400 transition-colors">
          <LogOut className="w-4 h-4" /> <span className="hidden md:inline">Log out</span>
        </button>
      </aside>
      <main className="flex-1 p-6 md:p-10 max-w-[1400px] w-full">
        <Outlet />
      </main>
    </div>
  );
}
